import { axios } from '@Root/API'

export const getAll = (courseSessionId, params) => {
  return axios.get(`/get/funding-and-monitoring/student-course-session/${courseSessionId}`, { params })
}
